import React, { useState, useEffect, useRef, useContext } from "react";
import { Alert, Card, Col, Container, Row } from "react-bootstrap";
import { Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {
  IconBasket1,
  IconBell,
  IconCancelTicket,
  IconClipBoard,
  IconCup,
  IconErrorCircle,
  IconFast,
  IconGift,
  IconNote,
  IconSecurity,
} from "../../../assets/icons";
import ReserveModal from "./component/reserveModal";
import AddToBasketButton from "../../components/addToBasketButton";
import SplitNumber from "../../components/SplitNumber";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import enamadImage from "../../../assets/images/e-namad.png";
import ApiRegion from "../../../core/api/api.region";
import saveCityDataToStorage from "../../components/GetCityListAndSaveToStorage";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { useParams, useNavigate, Link } from "react-router-dom";
import CommentScore from "./component/CommentScore";
import CommentSlider from "./component/CommentSlider";
import { Helmet } from "react-helmet";
import Slider from "./component/Slider";
import { ToastContainer, toast } from "react-toastify";
import CardTile from "../../components/CardTile";
import SkeletonDetailsContetnt from "../../components/SkeletonComponent/SkeletonDetailsContetnt";
import ServiceStorage from "../../../core/services/service.storage";
import ContextApp from "../../../core/contexts/context.app";
import { tools } from "../../../core/utils/tools";

import getCityDataAndSaveToStorage from "../../components/GetCityListAndSaveToStorage";

function IndexAmusementDetail() {
  const [loadingImageSlider, setLoadingImageSlider] = useState(true);
  const [dataImageSlider, setDataImageSlider] = useState([]);
  const [amusementService, setAmusementService] = useState({});
  const [galleries, setGalleries] = useState([]);
  const { urlName } = useParams(); // دریافت پارامتر urlName از روت
  const navigate = useNavigate();
  const ctx = useContext(ContextApp);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiAmusementService.getAmusementService({
          urlName,
        });
        setAmusementService(response);
        setGalleries(response.galleries);
        setLoadingImageSlider(false);
        const cityIdFromServer = response.defaultCityId;
        const storageCity = ServiceStorage.getCity();
        if (cityIdFromServer != null) {
          if (!_.isNil(storageCity)) {
            const cityList = JSON.parse(storageCity.cityList);
            const item = cityList.find((city) => city.id == cityIdFromServer)
            ctx.setSelectedCity(item);
            ServiceStorage.setSelectedCity(item);
          } else { // اطلاعاتی در داخل لوکال استوریچ وجود ندارد(دفعه اول)
            const { newUpdateDate, regoinResult } = await getCityDataAndSaveToStorage()
            const selectedCity = regoinResult.find((city) => city.id == cityIdFromServer);
            ctx.setSelectedCity(selectedCity);
            ServiceStorage.setCity({ cityListLastUpdate: newUpdateDate, cityList: regoinResult, selectedCity })
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingImageSlider(false); // بارگذاری تصاویر را به صورت پایانی تنظیم می‌کنیم
      }
    };
    fetchData();
  }, [urlName]);

  // async function getData() {
  //   try {
  //
  //     const response = await ApiAmusementService.getAmusementService({ urlName: urlName });
  //
  //     // var reserveDetailsTemp = _.attempt(JSON.parse.bind(null, response.reserveDetails));
  //     // setReserveDetails(reserveDetailsTemp);
  //      setAmusementService(response);

  //     // setGalleries(response.galleries);
  //     // // const timer = setTimeout(() => { setIsLoading(false) }, 5000)
  //     // setIsLoading(false);
  //     // setTestimonials(response.amusementTestimonials);
  //     // if (
  //     //   !_.isEmpty(reserveDetailsTemp) &&
  //     //   !_.isEmpty(reserveDetailsTemp.Child) &&
  //     //   _.size(reserveDetailsTemp.Child) <= 1
  //     // ) {
  //     //   placeSelected(reserveDetailsTemp.Child[0].AmusmentLocationId, reserveDetailsTemp.Child[0].AmusmentLocationName);
  //     // }
  //   } catch (error) { }
  // }

  /*** مدال رزرو ******************** */
  const [showReserveModal, setShowReserveModal] = useState(false);
  const handleShowModal = (value) => {
    //if(value)
    //navigate(`/reserve`, {
    //  replace: true,
    //});
    //else
    //navigate(-1);
    setShowReserveModal(value);
  };
  /************************** */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  /********************* */
  const SetColor = (rank) => {
    if (rank < 2) return "text-danger fs-103 fw-bold";
    else if (rank >= 4) return "text-success fs-103 fw-bold";
    else return "text-warning fs-103 fw-bold";
  };
  /************************ */
  //اسکرول به قسمت امتیازات در حالت دسکتاپ
  const ScrollGotoScore = useRef(null);
  const handleScrollGotoScore = () => {
    if (ScrollGotoScore.current) {
      ScrollGotoScore.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  /************************ */
  //اسکرول به قسمت نظرات در حالت دسکتاپ
  const ScrollGotoComment = useRef(null);
  const handleScrollGotoComment = () => {
    if (ScrollGotoComment.current) {
      ScrollGotoComment.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  /******************* */
  return (
    <>
      <ToastContainer position="top-right" rtl="true"></ToastContainer>
      {!_.isEmpty(amusementService) && (
        <div className="wrapper">
          <Helmet>
            <title>
              {!_.isEmpty(amusementService.pageTitle)
                ? amusementService.pageTitle
                : amusementService.name}
            </title>
            <link
              href={
                window.location.origin + "/details/" + amusementService.urlName
              }
              rel="canonical"
            ></link>
            <meta
              property="og:url"
              content={
                window.location.origin + "/details/" + amusementService.urlName
              }
            />
            <meta
              property="og:title"
              content={
                !_.isEmpty(amusementService.pageTitle)
                  ? amusementService.pageTitle
                  : amusementService.name
              }
            />
            <meta
              property="og:description"
              content={
                !_.isEmpty(amusementService.metaDescription)
                  ? amusementService.metaDescription
                  : "خرید ویژه با تخفیف ویژه"
              }
            />
            <meta
              name="description"
              content={
                !_.isEmpty(amusementService.metaDescription)
                  ? amusementService.metaDescription
                  : "خرید ویژه با تخفیف ویژه"
              }
            />
          </Helmet>
        </div>
      )}
      {isMobile ? (
        //**** * حالت موبایل**********************************
        <div className="bg-light-3">
          <Container className="pt-3 px-2">
            <Card className="rounded-3">
              <Card.Body className=" p-2">
                {loadingImageSlider ? (
                  <>
                    <SkeletonTheme>
                      <Skeleton
                        height={258}
                        width="100%"
                        style={{ borderRadius: "0.75rem" }}
                      ></Skeleton>
                    </SkeletonTheme>
                  </>
                ) : (
                  <Slider images={galleries} />
                )}

                <div className="mt-3">
                  {loadingImageSlider ? (
                    <SkeletonTheme>
                      <div className=" border-bottom pb-3">
                        <Skeleton height="25px" width="100%"></Skeleton>
                      </div>
                      <div className="d-flex justify-content-between mt-3 mb-2">
                        <div className="text-start w-50">
                          <Skeleton height="25px" width="80%"></Skeleton>
                        </div>
                        <div className="text-end w-50">
                          <Skeleton height="25px" width="80%"></Skeleton>
                        </div>
                      </div>
                      <Skeleton height="35px" width="100%"></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <>
                      <h1 className="text-center fw-bold fs-102 border-bottom pb-3">
                        {amusementService.name}
                      </h1>

                      {amusementService.hasReserveDetail_V2 ? (
                        <>
                          <Row className="gx-0 mt-3">
                            {amusementService?.originalPrice >
                            amusementService?.price ? (
                              /************** اگر تخفیف داشت **************************/
                              <>
                                <Col className="text-start text-secondary">
                                  <div className="fs-07">قیمت اولیه</div>
                                  <div className=" mt-1 fs-08">
                                    <span className="text-decoration-line-throught-rotate border-black fw-bold">
                                      <SplitNumber
                                        number={amusementService.originalPrice}
                                      />
                                    </span>
                                    <span className="ps-1">تومان</span>
                                  </div>
                                </Col>
                                <Col className="text-danger text-center ">
                                  <div className="small-svg fs-07 mb-1 ">
                                    <IconGift fillColor="#f80248" /> تخفیف
                                  </div>
                                  <div className="fs-08">
                                    <span className=" fw-bold mt-1 ">
                                      <SplitNumber
                                        number={
                                          amusementService?.originalPrice -
                                          amusementService?.price
                                        }
                                      />
                                    </span>
                                    <span className="ps-1">تومان</span>
                                  </div>
                                </Col>
                                <Col className="text-black text-end">
                                  <div className="fs-07 text-secondary">
                                    قیمت نهایی
                                  </div>
                                  <div className="fs-08 mt-1">
                                    <span className="fw-bold fs-09">
                                      <SplitNumber
                                        number={amusementService.price}
                                      />
                                    </span>
                                    <span className="ps-1">تومان</span>
                                  </div>
                                </Col>
                              </>
                            ) : (
                              /************** اگر تخفیف نداشت **************************/
                              <Col className="text-black d-flex justify-content-between align-items-center">
                                <div className="fs-07 text-secondary">
                                  قیمت نهایی
                                </div>
                                <div className="fs-08 mt-1">
                                  <span className="fw-bold fs-09">
                                    <SplitNumber
                                      number={amusementService.price}
                                    />
                                  </span>
                                  <span className="ps-1">تومان</span>
                                </div>
                              </Col>
                            )}
                          </Row>
                          <button
                            className="btn btn-success d-flex align-items-center w-100 p-0 btn-with-icon mt-3"
                            onClick={handleShowModal}
                          >
                            <div className="border-end border-success icon-span ">
                              <IconBasket1 fillColor="#fff" />
                            </div>
                            <div className=" text-center flex-fill">
                              افزودن به سبد خرید
                            </div>
                          </button>
                          {amusementService.hasReserveDetail_V2 ? (
                            <div className="mt-2 fs-075">
                              <IconErrorCircle fillColor="#444" />
                              جهت مشاهده سانس و تاریخ، روی دکمه{" "}
                              <span
                                className="text-success px-1"
                                onClick={handleShowModal}
                              >
                                «افزودن به سبد خرید»
                              </span>
                              کلیک نمایید
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        <>
                          <Alert
                            variant="danger"
                            className="py-2 px-1 fs-075 mt-3 mb-0"
                          >
                            <IconErrorCircle fillColor="#58151c" /> تا اطلاع
                            ثانوی این تفریح غیرفعال می باشد.
                          </Alert>
                        </>
                      )}
                    </>
                  )}
                </div>
              </Card.Body>
              <Card.Footer className="bg-light border-top px-2">
                {/**** آیکن های اعتمادسازی *********************************/}
                <Row className="gx-0 text-dark  small-svg">
                  <Col className="pe-0 ">
                    <div className="fw-bold fs-065">
                      <span className="me-1">
                        <IconCancelTicket fillColor="#09a463" />
                      </span>
                      امـکان کنـسلـی
                    </div>
                    <div className="fs-055 mt-1">به صورت آنلاین و تلفنی</div>
                  </Col>
                  <Col className="pe-0">
                    <div className="fw-bold fs-065">
                      <span className="me-1">
                        <IconFast fillColor="#09a463" />
                      </span>
                      صدور آنی بلیط
                    </div>
                    <div className="fs-055 mt-1">بدون نیاز به چاپ بلیط</div>
                  </Col>
                  <Col className="pe-0">
                    <div className="fw-bold fs-065">
                      <span className="me-1">
                        <IconSecurity fillColor="#09a463" />
                      </span>
                      تضـمین قیـمت
                    </div>
                    <div className="fs-055 mt-1">تفریحات با بیشترین تخفیف</div>
                  </Col>
                </Row>
              </Card.Footer>
            </Card>

            <Card className="rounded-3 text-center mt-3">
              <Card.Body>
                <div>
                  <span className="pe-2">
                    <IconBell fillColor="#000" />
                  </span>
                  <h2 className="d-inline-block fw-bold fs-normal pb-3">
                    نکات مهم و ضروری {amusementService.name}
                  </h2>
                </div>
                {loadingImageSlider ? (
                  <SkeletonTheme>
                    <Skeleton height="15px" count={5}></Skeleton>
                  </SkeletonTheme>
                ) : (
                  <div
                    className="text-align-justify description-text"
                    dangerouslySetInnerHTML={{
                      __html: amusementService.alerts,
                    }}
                  />
                )}
              </Card.Body>
            </Card>

            <Card className="rounded-3 text-center mt-3">
              <Card.Body>
                <div>
                  <span className="pe-2">
                    <IconNote fillColor="#000" />
                  </span>
                  <h2 className="d-inline-block fw-bold fs-normal pb-3">
                    بررسی اجمالی {amusementService.name}
                  </h2>
                </div>
                {loadingImageSlider ? (
                  <SkeletonTheme>
                    <Skeleton height="15px" count={5}></Skeleton>
                  </SkeletonTheme>
                ) : (
                  <div
                    className="text-align-justify description-text"
                    dangerouslySetInnerHTML={{
                      __html: amusementService.description,
                    }}
                  />
                )}
              </Card.Body>
            </Card>

            {showReserveModal && (
              <ReserveModal
                showReserveModal={showReserveModal}
                setShowReserveModal={setShowReserveModal}
                serviceInfo={{
                  id: amusementService.id,
                  name: amusementService.name,
                  urlName: urlName,
                  imageUrl: amusementService.imageUrl,
                }}
              />
            )}
          </Container>

          {/****  e-namad  ***************************************************/}
          <Container className="px-2">
            <Card
              className="mt-3 rounded-3  bg-white text-dark "
              style={{ lineHeight: "1.4rem" }}
            >
              <Card.Body className="py-2">
                <Row>
                  <Col className="pe-0 my-auto fs-08">
                    <div className="">
                      این وب سایت دارای{" "}
                      <span className="fw-bold">مجوز رسمی</span>
                    </div>
                    <div className="">
                      از{" "}
                      <span className="fw-bold">
                        سازمان میراث فرهنگی و گردشگری
                      </span>{" "}
                      و
                    </div>
                    <div>
                      <span className="fw-bold">وزارت صنعت و معدن</span> می
                      باشد.
                    </div>
                  </Col>
                  <Col xs="auto" className="text-end my-auto px-1">
                    <div>
                      <a
                        referrerPolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                      >
                        <img
                          alt="eNamad"
                          referrerPolicy="origin"
                          className="rounded-3 h-100 "
                          src={enamadImage}
                          style={{ cursor: "pointer", width: "70px" }}
                          id="A32132KLXam6f2jcPJyV"
                        />
                      </a>
                    </div>
                    {/* <img
                      src={enamadImage}
                      alt="map"
                      style={{ width: "70px" }}
                    /> */}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
          {/******** تفریحات مرتبط ***************************/}
          {/* <Container className="mt-4 pb-2">
            <h3 className=" fw-bold fs-102 "> تفریحات مرتبط </h3>
            {!loadingImageSlider ? (
              <Swiper
                className="amusement-swiper"
                spaceBetween={10}
                slidesPerView={"auto"}
              >
                <SwiperSlide>
                  <SkeletonDetailsContetnt />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonDetailsContetnt />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonDetailsContetnt />
                </SwiperSlide>
              </Swiper>
            ) : (
              <Swiper
                className="amusement-swiper"
                spaceBetween={10}
                slidesPerView={"auto"}
              >
                {/* {liveData?.mostPopularAmusementServices?.map((item) => (
                <SwiperSlide key={item.id}>
                  <CardTile
                    itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                    amusementUrl={`/details/${item.urlName}`}
                    amusementName={item.name}
                    amusementPrice={item.price}
                    amusementFinalPrice={item.originalPrice}
                    handleClick={handleClick}
                  />
                </SwiperSlide>
              ))} 
              </Swiper>
            )}
          </Container> */}
          <Container fluid className="bg-light-blue pb-3">
            <section>
              <CommentSlider amusementService={amusementService} />
            </section>
          </Container>

          {/* نوار سفید رنگ پایین که اگر تفریحی رزرو داشت نمایش داده می شود */}
          {amusementService.hasReserveDetail_V2 ? (
            <div
              className="d-flex justify-content-between align-items-center  w-100 bg-white px-3 py-3 position-fixed "
              style={{
                bottom: "56px",
                zIndex: "1044",
                borderTop: "1px solid #e7e6e6",
              }}
            >
              <div className="fs-075 fw-normal">
                {amusementService.originalPrice > amusementService.price ? (
                  <div className="mb-1 text-secondary">
                    <span className="text-decoration-line-throught-rotate border-black fw-bold">
                      <SplitNumber number={amusementService.originalPrice} />
                    </span>
                    <span className="ps-1">تومان</span>
                  </div>
                ) : (
                  ""
                )}

                <div className="fw-bold fs-09">
                  <SplitNumber number={amusementService.price} />
                  <span className="ps-1">تومان</span>
                </div>
              </div>

              <div>
                <div
                  onClick={handleShowModal}
                  className="btn btn-danger text-white fs-09"
                >
                  افزودن به سبد خرید
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        //**** * حالت دسکتاپ**********************************
        <>
          <Container fluid className="bg-light-3 pb-3">
            <Container className="pt-4 px-0">
              <Row className="gx-2">
                <Col lg="4" xl="5">
                  <Card className="rounded-3 border-0 shadow-sm p-2">
                    {loadingImageSlider ? (
                      <>
                        <SkeletonTheme>
                          <Skeleton
                            height={258}
                            width="100%"
                            style={{ borderRadius: "0.75rem" }}
                          ></Skeleton>
                        </SkeletonTheme>
                      </>
                    ) : (
                      <Slider images={galleries} />
                    )}
                  </Card>
                </Col>
                <Col lg="8" xl="7" className=" pt-3 pt-lg-0">
                  <Card className="rounded-3 bg-white border-0  shadow-sm h-100">
                    <Card.Body className="pb-0">
                      <Col xs={12}>
                        <Row className="text-primary1 pb-3">
                          <Col xs className=" my-auto">
                            {!loadingImageSlider ? (
                              <h1 className="fw-bold mb-0 fs-103 border-light-blue">
                                {amusementService.name}
                              </h1>
                            ) : (
                              <Skeleton height="25px" width="50%"></Skeleton>
                            )}
                          </Col>
                          <Col md="auto" className=" my-auto small-svg">
                            <div className="d-flex align-items-center ">
                              <div className="text-center">
                                <div
                                  className="fs-075 small-svg white-space-nowrap cursor-pointer"
                                  onClick={handleScrollGotoScore}
                                >
                                  <span className="pe-1">
                                    <IconCup fillColor="#444" />
                                  </span>
                                  امتیاز
                                  <span className=" fs-normal ps-1">
                                    {!loadingImageSlider ? (
                                      amusementService.totalRank
                                    ) : (
                                      <Skeleton
                                        height="17px"
                                        width="15px"
                                      ></Skeleton>
                                    )}
                                  </span>{" "}
                                </div>
                              </div>

                              <div
                                className="text-center  ms-2 ps-2 cursor-pointer"
                                onClick={handleScrollGotoComment}
                              >
                                <div className="fs-075 small-svg white-space-nowrap ">
                                  <span className="pe-1">
                                    <IconClipBoard fillColor="#444" />
                                  </span>
                                  نظرات
                                  <span className=" fs-normal  ps-1">
                                    {!loadingImageSlider ? (
                                      amusementService?.amusementTestimonials
                                        ?.length
                                    ) : (
                                      <Skeleton
                                        height="17px"
                                        width="15px"
                                      ></Skeleton>
                                    )}
                                  </span>{" "}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="border-top py-3">
                            {loadingImageSlider ? (
                              <Row className="mb-3 mt-2">
                                <Col md="3" xl="3" className="pe-0">
                                  <Skeleton
                                    height="40px"
                                    width="70%"
                                  ></Skeleton>
                                </Col>
                                <Col
                                  md="3"
                                  xl="3"
                                  className="text-center text-danger "
                                >
                                  <Skeleton
                                    height="40px"
                                    width="70%"
                                  ></Skeleton>
                                </Col>
                                <Col md="3" lg="2" xl="3" className="text-end ">
                                  <Skeleton
                                    height="40px"
                                    width="70%"
                                  ></Skeleton>
                                </Col>
                                <Col md="3" lg="4" xl="3">
                                  <Skeleton
                                    height="40px"
                                    width="100%"
                                  ></Skeleton>
                                </Col>
                                <Col xs="12" className="border-top mt-3"></Col>
                              </Row>
                            ) : amusementService.hasReserveDetail_V2 ? (
                              <>
                                <Row className="mb-3 mt-2">
                                  <Col md="3" xl="3" className="pe-0">
                                    <>
                                      <div className="fs-07 text-black-06  pb-2">
                                        قیمت اولیه
                                      </div>
                                      <div>
                                        {!loadingImageSlider ? (
                                          <>
                                            <span className="text-decoration-line-throught-rotate border-black ">
                                              <SplitNumber
                                                number={
                                                  amusementService.originalPrice
                                                }
                                              />
                                            </span>{" "}
                                            تومان
                                          </>
                                        ) : (
                                          <Skeleton
                                            height="17px"
                                            width="50%"
                                          ></Skeleton>
                                        )}
                                      </div>
                                    </>
                                  </Col>
                                  <Col
                                    md="3"
                                    xl="3"
                                    className="text-center text-danger px-0"
                                  >
                                    <>
                                      <div className="text-center text-danger fs-07 pb-2">
                                        تخفیف ویژه
                                      </div>
                                      <div>
                                        {!loadingImageSlider ? (
                                          <>
                                            <span className=" small-svg">
                                              <span className="d-lg-none d-xl-inline-block pe-1">
                                                <IconGift fillColor="#f80248" />{" "}
                                              </span>
                                              <SplitNumber
                                                number={
                                                  amusementService?.originalPrice -
                                                  amusementService?.price
                                                }
                                              />{" "}
                                            </span>{" "}
                                            تومان
                                          </>
                                        ) : (
                                          <Skeleton
                                            height="17px"
                                            width="50%"
                                          ></Skeleton>
                                        )}
                                      </div>
                                    </>
                                  </Col>
                                  <Col
                                    md="3"
                                    lg="2"
                                    xl="3"
                                    className="text-end px-0"
                                  >
                                    <div className="fs-07 text-black-06 pb-1">
                                      قیمت نهایی
                                    </div>
                                    <div>
                                      {!loadingImageSlider ? (
                                        <>
                                          <span className=" fw-bold fs-103">
                                            <SplitNumber
                                              number={amusementService.price}
                                            />
                                          </span>
                                          تومان
                                        </>
                                      ) : (
                                        <Skeleton
                                          height="17px"
                                          width="50%"
                                        ></Skeleton>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md="3" lg="4" xl="3">
                                    <button
                                      className="btn btn-danger white-space-nowrap text-center fs-normal w-100 py-3"
                                      onClick={handleShowModal}
                                    >
                                      افزودن به سبد خرید
                                    </button>
                                  </Col>
                                  <Col
                                    xs="12"
                                    className="border-top mt-3"
                                  ></Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                <Alert
                                  variant="danger"
                                  className="p-2 fs-085 mt-2 mb-3 d-inline-block"
                                >
                                  <IconErrorCircle fillColor="#58151c" /> تا
                                  اطلاع ثانوی این تفریح غیرفعال می باشد.
                                </Alert>
                              </>
                            )}

                            <Row>
                              <Col md className="pe-0 ps-2">
                                {amusementService.hasReserveDetail_V2 ? (
                                  <div className=" text-orange fs-08 ">
                                    <IconErrorCircle fillColor="#f76900db" />
                                    جهت مشاهده سانس و تاریخ، روی دکمه{" "}
                                    <span
                                      className="cursor-pointer px-1"
                                      onClick={handleShowModal}
                                    >
                                      «افزودن به سبد خرید»
                                    </span>
                                    کلیک نمایید.
                                  </div>
                                ) : (
                                  " "
                                )}
                                <div className="fs-08 my-3 ">
                                  <IconErrorCircle fillColor="#444" />
                                  لطفا قبل از خرید این تفریح، نکات مهم و ضروری
                                  را مطالعه نمایید.
                                </div>
                                <div className="fs-08 small-svg text-success">
                                  <span className="me-1">
                                    <IconSecurity fillColor="#09a463" />
                                  </span>
                                  این سایت دارای{" "}
                                  <span className="fw-bold">مجوز رسمی</span> از
                                  سازمان میراث فرهنگی و گردشگری و وزارت صنعت و
                                  معدن می باشد.
                                </div>
                              </Col>
                              <Col xs="auto" className="text-end my-auto px-1">
                                <div className=" ">
                                  <a
                                    referrerPolicy="origin"
                                    target="_blank"
                                    href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                                  >
                                    <img
                                      alt="eNamad"
                                      referrerPolicy="origin"
                                      className="rounded-3 h-100 "
                                      src={enamadImage}
                                      style={{
                                        cursor: "pointer",
                                        width: "95px",
                                      }}
                                      id="A32132KLXam6f2jcPJyV"
                                    />
                                  </a>
                                </div>
                                {/* <img
                                  src={enamadImage}
                                  alt="map"
                                  style={{ width: "95px" }}
                                /> */}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Card.Body>
                    <Card.Footer className="border-top bg-light rounded-bottom-3">
                      {/**** آیکن های اعتمادسازی *********************************/}
                      <div className="d-flex justify-content-between small-svg py-1">
                        <div className="d-flex">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconCancelTicket fillColor="#09a463" />
                            </span>
                            امکان کنسلی
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            به صورت آنلاین و تلفنی
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconFast fillColor="#09a463" />
                            </span>
                            صدور آنی بلیط
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            بدون نیاز به چاپ بلیط
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconSecurity fillColor="#09a463" />
                            </span>
                            تضمین قیمت
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            تفریحات با بیشترین تخفیف
                          </div>
                        </div>
                      </div>
                      {/* <Row className="gx-0  text-dark-blue py-1 rounded-3 small-svg ">
                        <Col className="pe-0 text-center d-lg-flex justify-content-center justify-content-lg-start">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconCancelTicket fillColor="#09a463" />
                            </span>
                            امکان کنسلی
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            به صورت آنلاین و تلفنی
                          </div>
                        </Col>
                        <Col className="pe-0  text-center d-lg-flex justify-content-center">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconFast fillColor="#09a463" />
                            </span>
                            صدور آنی بلیط
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            بدون نیاز به چاپ بلیط
                          </div>
                        </Col>
                        <Col className="pe-0  text-center d-lg-flex justify-content-center justify-content-lg-end">
                          <div className="fw-bold fs-07">
                            <span className="me-1">
                              <IconSecurity fillColor="#09a463" />
                            </span>
                            تضمین قیمت
                          </div>
                          <div className="fs-07 ps-1 ps-lg-2">
                            تفریحات با بیشترین تخفیف
                          </div>
                        </Col>
                      </Row> */}
                    </Card.Footer>
                  </Card>
                </Col>
              </Row>

              <Card className="rounded-3 shadow-sm border-0 bg-white  mt-3">
                <Card.Body>
                  <div>
                    <span className="pe-2">
                      <IconBell fillColor="#000" />
                    </span>

                    <h2 className="d-inline-block fw-bold fs-102 pb-3">
                      نکات مهم و ضروری {amusementService.name}
                    </h2>
                  </div>
                  {loadingImageSlider ? (
                    <SkeletonTheme>
                      <Skeleton height="15px" count={5}></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <div
                      className="text-align-justify description-text"
                      dangerouslySetInnerHTML={{
                        __html: amusementService.alerts,
                      }}
                    />
                  )}
                </Card.Body>
              </Card>

              <Card className="rounded-3 shadow-sm border-0 bg-white  mt-3">
                <Card.Body>
                  <div>
                    <span className="pe-2">
                      <IconNote fillColor="#000" />
                    </span>
                    <h2 className="d-inline-block fw-bold fs-102 pb-3">
                      بررسی اجمالی {amusementService.name}
                    </h2>
                  </div>
                  {loadingImageSlider ? (
                    <SkeletonTheme>
                      <Skeleton height="15px" count={5}></Skeleton>
                    </SkeletonTheme>
                  ) : (
                    <div
                      className="text-align-justify description-text"
                      dangerouslySetInnerHTML={{
                        __html: amusementService.description,
                      }}
                    />
                  )}
                </Card.Body>
              </Card>

              {showReserveModal && (
                <ReserveModal
                  showReserveModal={showReserveModal}
                  setShowReserveModal={setShowReserveModal}
                  serviceInfo={{
                    id: amusementService.id,
                    name: amusementService.name,
                    urlName: urlName,
                    imageUrl: amusementService.imageUrl,
                  }}
                />
              )}
            </Container>
          </Container>

          <Container fluid className="bg-light-3" ref={ScrollGotoScore}>
            <Container className="px-0">
              <CommentScore amusementService={amusementService} />

              {/******** تفریحات مرتبط ***************************/}
              {/* <Container className="px-0 pb-2 pt-5">
                <h3 className=" fw-bold fs-102 "> تفریحات مرتبط </h3>
                {!loadingImageSlider ? (
                  <Swiper
                    className="amusement-swiper"
                    spaceBetween={10}
                    slidesPerView={"auto"}
                  >
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                  </Swiper>
                ) : (
                  <Swiper
                    className="amusement-swiper"
                    spaceBetween={10}
                    slidesPerView={"auto"}
                  >
                    {/* {liveData?.mostPopularAmusementServices?.map((item) => (
                <SwiperSlide key={item.id}>
                  <CardTile
                    itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                    amusementUrl={`/details/${item.urlName}`}
                    amusementName={item.name}
                    amusementPrice={item.price}
                    amusementFinalPrice={item.originalPrice}
                    handleClick={handleClick}
                  />
                </SwiperSlide>
              ))} 
                  </Swiper>
                )}
              </Container> */}
              <section ref={ScrollGotoComment}>
                <CommentSlider amusementService={amusementService} />
              </section>
            </Container>
          </Container>
        </>
      )}
    </>
  );
}

export default IndexAmusementDetail;
